import DefaultShellContentModel, * as defaultShellContentModels from './contentmodel';

export const ContentModels = defaultShellContentModels;
export const ContentModel = DefaultShellContentModel;

import style from './style.css';

export const description = "This is the default-simulation-shell";
export const instructions = `
These are the default-simulation-shell installation instructions:
  Step 1...
  Step 2...
  Step 3...
`;



// WEBPACK FOOTER //
// ./app_modules/default-simulation-shell/index.js